define([
    'text!WebCommon/modal/fnji-weixin.html',
    'WebCommon/mixin/modal',

    'css!WebCommon/modal/fnji-weixin.css'
], function(
    tpl,
    ModalMixin
){
    return {
        template: tpl,
        mixins: [ModalMixin]
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/modal/fnji-weixin.js
// module id = 51
// module chunks = 0 1 2 3